import { CartApiError } from '../cartApi'

export const asErrorMessage = (error: unknown) => {
  if (error instanceof CartApiError) return error.message
  if (error instanceof Error && error.message.trim()) return error.message
  return 'Errore gestione carrello'
}

export const normalizeQuantity = (value: number) => {
  if (!Number.isFinite(value)) return 1
  return Math.max(1, Math.trunc(value))
}
